import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.portal.isAppReady)
      ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
          align: "left",
          class: "btn-fixed-width",
          color: "primary",
          icon: "keyboard_arrow_left",
          label: _ctx.$t(_ctx.portal.getButtonText(true)),
          id: "btnBack"
        }, null, 8, ["label"])), [
          [_vShow, !_ctx.portal.shouldHideBackButton()]
        ])
      : _createCommentVNode("", true),
    (!_ctx.portal.shouldHideSkipButton())
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('skip'))),
          flat: "",
          color: "primary",
          label: _ctx.$t('portal_btnSkip'),
          class: "q-ml-auto",
          id: "btnSkip"
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    (_ctx.portal.isAppReady)
      ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next'))),
          align: "right",
          class: _normalizeClass(["btn-fixed-width", { 'q-ml-auto': _ctx.portal.navPageConfig.length ? _ctx.portal.shouldHideSkipButton() : true } ]),
          color: "primary",
          "icon-right": "keyboard_arrow_right",
          label: _ctx.$t(_ctx.portal.getButtonText(false)),
          disable: _ctx.portal.disableNext,
          id: "btnNext"
        }, null, 8, ["class", "label", "disable"])), [
          [_vShow, !_ctx.portal.shouldHideNextButton()]
        ])
      : _createCommentVNode("", true)
  ], 64))
}